// SPDX-License-Identifier: AGPL-3.0-or-later

import {PremiumExperience} from '@app/features/premium/components/experience/PremiumExperience';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const PlutoniumTab: React.FC = observer(() => {
	return <PremiumExperience variant="embedded" />;
});

export default PlutoniumTab;
